import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT } from '../utils/Constants';
import { toast } from 'react-toastify';
import RoutePath from '../utils/routes/RoutePath';
import VendorRoomList from '../component/VendorRoomList';
import { getSavedPage, setSavedPage } from '../utils/paginationState';

const PAGINATION_KEY = 'vendor-room-list';

class VendorRoom extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: getSavedPage(PAGINATION_KEY),
            totalItem: '',
            searchText: '',
        }
    }
    componentDidMount() {
        this.getRoomList()
    }

    getRoomList = (currentPage = this.state.pageNumber) => {
        const { searchText } = this.state;
        let params = {
            limit: LIMIT,
            pageNumber: currentPage > 0 ? currentPage-1 : 0,
            search: searchText,
        }
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.props.getRoomList(params, callback)
    }
    onChangePagination = (pageNumber) => {
        const { searchText } = this.state;
        let params = {
            pageNumber: (pageNumber - 1),
            limit: LIMIT,
            search: searchText,
        }
        setSavedPage(PAGINATION_KEY, pageNumber);
        this.setState({ pageNumber: pageNumber });
        this.props.getRoomList(params, '')
    }
    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchText: value, pageNumber: 1 }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getRoomList(1);
        });
    }
    clearSearch = () => {
        this.setState({ searchText: '', pageNumber: 1 }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getRoomList(1);
        });
    }
    updateVendorRoom = (id, active) => {
        const updateParams = {
            id,
            isActive: active ? 0 : 1
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getRoomList(this.state.pageNumber)
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.updateVendorRoom(updateParams, callback)
    }
    deleteVendorRoom = (id) => {
        const isConfirmed = window.confirm("Are you sure you want to permanently delete this room?");
        if (!isConfirmed) {
            return;
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success("Room deleted successfully")
                this.getRoomList(this.state.pageNumber)
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.deleteVendorRoom({ id }, callback)
    }
    addProduct = () => {
        this.props.history.push(RoutePath.VENDOR_ROOM_ADD)
    }

    viewRoom = (id) => {
            this.props.history.push("/vendor/room/view/" + id)
    }

    editRoom = (id) => {
        this.props.history.push("/vendor/room/edit/" + id);
    }

    render() {
        const { pageNumber, isVendor, searchText } = this.state;
        const { getRoom = {} } = this.props
        const { isLoading, vendorRoomListData } = getRoom
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" type="button" onClick={() => this.addProduct()}><i className="fa-solid fa-plus me-3"></i>Add Room</button>
                            </div>
                            <div className="add-btn search-box">
                                <input
                                    className="form-control search-input"
                                    placeholder="Search by room id / room name"
                                    value={searchText}
                                    onChange={this.handleSearchChange}
                                />
                                {searchText ? <button type="button" className="search-clear-btn" onClick={this.clearSearch}>x</button> : null}
                            </div>
                        </div>
                        <VendorRoomList vendorRoomList={vendorRoomListData?.rooms} 
                            updateStatus={(id, active) => this.updateVendorRoom(id, active)}
                            deleteRoom={(id) => this.deleteVendorRoom(id)}
                            isVendor={isVendor}
                            currentPage={pageNumber}
                            viewRoom={(id) => this.viewRoom(id)}
                            editRoom={(id) => this.editRoom(id)} />
                        <div className='page-content'>
                            {
                                vendorRoomListData?.totalItems > (LIMIT - 1) ? 
                                <PaginationComponenent 
                                currentPage={pageNumber} 
                                countValue={vendorRoomListData?.totalItems} 
                                onChangeHandle={this.onChangePagination} /> : ''
                            }
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getRoom: Actions.getRoom(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getRoomList: Actions.getRoomList,
    updateVendorRoom: Actions.updateVendorRoom,
    deleteVendorRoom: Actions.deleteVendorRoom
})(VendorRoom));